import unescapedText from 'I18n/utils/unescapedText';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { SortTableIcon } from 'foundations-assets/icons/components/SortTableIcon';
import { SortTableAscNewIcon } from 'foundations-assets/icons/components/SortTableAscNewIcon';
import { SortTableDescNewIcon } from 'foundations-assets/icons/components/SortTableDescNewIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const getLabelText = sort => {
  if (sort === 'ascending') {
    return unescapedText('ui.UISortTH.ascendingSort');
  }
  if (sort === 'descending') {
    return unescapedText('ui.UISortTH.descendingSort');
  }
  return unescapedText('ui.UISortTH.pressToSort');
};
const StyledSpan = styled.span.withConfig({
  displayName: "TableSortArrows__StyledSpan"
})(({
  theme,
  $cssStyles,
  $sorted
}) => {
  return Object.assign({
    display: 'inline-block',
    flexShrink: 0,
    marginLeft: `calc(${theme.space[50]} + ${theme.space[100]})`,
    marginRight: theme.space[0],
    color: $sorted ? theme.color['icon-interactive-default'] : theme.color['icon-core-default'],
    '& svg': {
      verticalAlign: 'middle'
    }
  }, $cssStyles);
});
export const TableSortArrows = props => {
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    sort
  } = restProps;
  const isSorted = sort !== 'none';
  const renderIcon = () => {
    if (sort === 'ascending') {
      return /*#__PURE__*/_jsx(SortTableAscNewIcon, {});
    }
    if (sort === 'descending') {
      return /*#__PURE__*/_jsx(SortTableDescNewIcon, {});
    }
    return /*#__PURE__*/_jsx(SortTableIcon, {});
  };
  return /*#__PURE__*/_jsx(StyledSpan, Object.assign({}, domProps, callbackProps, {
    "aria-label": getLabelText(sort),
    "aria-live": "polite",
    role: "presentation",
    $cssStyles: cssStyles,
    $sorted: isSorted,
    children: renderIcon()
  }));
};